"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var __jsx = _react.default.createElement;
var TableOfContentsEditConfig = {
  emptyLabel: 'Table of Contents',
  isEmpty: function isEmpty(props) {
    return !props || !props.cqPath;
  }
};
var TableOfContents = function TableOfContents(props) {
  return __jsx("div", {
    className: "cmp-tableofcontents"
  });
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/tableofcontents')(TableOfContents, TableOfContentsEditConfig);
exports.default = _default;